import React from 'react';

import {Outlet} from 'react-router-dom';

import {ConfigProvider} from 'antd';

export default function AppContent() {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Carousel: {
                        /* 这里是你的组件 token */
                        dotOffset: -24,
                        dotHeight: 12,
                        dotWidth: 12,
                        dotActiveHeight: 12,
                        dotActiveWidth: 12,
                    },
                    Breadcrumb: {
                        /* 这里是你的组件 token */
                        itemColor: '#000',
                        lastItemColor: '#000',
                    },
                },
            }}
        >
            <Outlet />
        </ConfigProvider>
    );
}
